
<template>
  <v-footer dark padless app>
    <v-card flat tile width="100%" class="text-center" :color="setting.COLOR">
      <template v-if="!boolUpdateVersion">
        <div class="d-flex justify-space-between">
          <div class="pa-2" dark>
            <strong>{{ strDateTime }}</strong>
          </div>
          <div class="pa-2">
            <strong>Jianfeng YE</strong>
            <strong>
              <v-icon class="mb-2" color="white" size="15"
                >mdi-copyright</v-icon
              >
            </strong>
          </div>
          <div class="pa-2">
            <strong class="mr-2">
              VERSION
              {{ strVersion }}
            </strong>
            <v-btn
              v-if="strNewVersion"
              class="mx-3"
              :color="setting.COLOR"
              rounded
              dark
              @click="updateVersion"
            >
              Update to {{ strNewVersion }}
              <v-icon right dark>mdi-cached</v-icon>
            </v-btn>
          </div>
        </div>
      </template>
      <template v-else>
        <v-card-text>
          <v-progress-linear
            class="text-md-center"
            :color="strSnackBarColor"
            height="20"
            :value="intPersent"
            striped
          >
            <strong>{{ strInfomation }}</strong>
          </v-progress-linear>
        </v-card-text>
      </template>
    </v-card>
  </v-footer>
</template>

<script>
import { mapState } from "vuex";
import config from "../../package.json";
import moment from "moment";

export default {
  name: "AppFooter",

  data: () => ({
    strSnackBarColor: "#1CD0CD",
    boolUpdateVersion: false,
    intPersent: 0,
    strInfomation: "",
    strVersion: config.version,
    strDateTime: moment().format("YYYY-MM-DD"),
  }),
  props: {
    strNewVersion: null,
  },
  created() {
    if (this.strNewVersion) {
      this.boolUpdateVersion = true;
    }
  },
  mounted() {
    // console.log(moment().format("YYYYMMDD"));
    // this.strDateTime = moment().format("YYYYMMDD");
  },
  methods: {
    updateVersion() {},
  },
  computed: mapState({
    objUserInfo: "profile",
    setting: "setting",
  }),
};
</script>
